export default class ReportingService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getDateRange(rangeType) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/reports/daterange/${rangeType}`);
  }

  getFavoriteReports(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/reports/listfavorites/${entityId}`);
  }

  updateFavoriteReports(entityId,reportIds) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/reports/updatefavorites/${entityId}/${reportIds}`);
  }

  availableReportsByCategory(entityId,roleId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/reports/list/${entityId}/${roleId}`);
  }

  runReport(reportName, criteria) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/reports/${reportName}`, criteria);
  }

  runVisualReport(reportName, criteria) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/visualreports/${reportName}`, criteria);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/reports/reporting.Service.js